import { createSlice } from "@reduxjs/toolkit";

const initialUsersState = {
  entities: [],
  totalCount: 0,
  listLoading: false,
  actionsLoading: false,
  rolePermission: [],
  completed: false,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const usersSlice = createSlice({
  name: "users",
  initialState: initialUsersState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // users fetched from api
    usersFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    setRolePermissions: (state, action) => {
      state.rolePermission = action.payload;
      state.actionsLoading = false;
    },

    resetRolePermissions: (state, action) => {
      state.rolePermission = [];
    },

    // users changed Password
    changedPassword: (state, action) => {
      const { message } = action.payload;
      state.actionsLoading = false;
      state.message.success = message;
    },
    // users fetched from api
    userCreated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.entities.push(entity);
      state.totalCount = state.totalCount + 1;
      state.message.success = message;
      state.completed = true;
    },
    userUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      if (entity?.id) {
        state.entities = state.entities.map((row) => {
          if (row.id === entity.id) {
            return {
              ...row,
              ...entity,
            };
          }
          return row;
        });
      }
      state.message.success = message;
      state.completed = true;
    },
    statusChanged: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.entities = state.entities.map((row) => {
        if (row.id === entity.id) {
          row = entity;
        }
        return row;
      });
      state.message.success = message;
    },
    userAccessPatched: (state, action) => {
      const { id, payload } = action.payload;
      state.entities = state.entities.map((row) => {
        if (row.id === id) {
          return {
            ...row,
            ...payload,
          };
        }
        return row;
      });
    },
    setStatusBack: (state, action) => {
      const { id, status } = action.payload;
      state.actionsLoading = false;
      state.entities = state.entities.map((row) => {
        if (row.id === parseInt(id)) {
          row.status = status;
        }
        return row;
      });
    },

    //change complete status
    changeCompleteStatus: (state, action) => {
      const { status } = action.payload;
      state.completed = status;
    },

    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
  },
});
